import { Button, Card, CardContent, Grid, Toolbar, Typography, makeStyles, RadioGroup, FormControlLabel, Radio, useMediaQuery } from "@material-ui/core";
import { ChevronLeft } from '@material-ui/icons';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_CART_ENABLED, STEP_LOCATION, STEP_SERVICE_PACKAGES } from 'pages/CustomerBookingCreate/constants';
import { activeServiceState, autoPopupServiceState, bookingRegionState, bookingState, cartLoadingState, cartState, cartVisibleState, clearCartState, confirmChangeLocationState, packagesState, servicesState, sessionTokenState, stepState } from "pages/CustomerBookingCreate/state";
import { DEFAULTLOCATION } from 'pages/CustomerBookingCreate/state'
import { Suspense, useCallback, useEffect, useState } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { getFeaturedCategories, getServicableAreas, getServices } from 'services/service.service';
import { ServiceRows } from './ServiceRows';
import { mapCategoriesToServices } from './processor';
import { useTrackEvent } from 'util/trackEvent';
import { useHistory } from 'react-router-dom';
import { useMapPrefilledHook } from './useMapPrefilledHook';
import { verifyIfLocationSupported } from 'services/booking.service';
import { isAuthenticated, useUserState } from 'services/authentication.service';
import { isCartValidForService, isLocationSupportedForService } from 'util/availability';
import { useUpdateEffect } from "usehooks-ts";
import { CartButton } from "pages/CustomerBookingCreate/components/PageHeader/CartButton";

const useStyles = makeStyles(theme => ({
  dragcontainer: {
    height: 250,
    width: '1000px',
    overflow: "hidden",
    overflowX: "scroll",
  },
  locCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  map: {
    width: '50vh',
    height: 'auto'
  },
  city: {
    fontWeight: 'bold',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  }
}));
const ServicePackagesScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const trackEvent = useTrackEvent()
  const history = useHistory()
  const [serviceCategories, setServiceCategories] = useState([]);
  const [enableCart, setEnableCart] = useRecoilState(cartVisibleState);
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useRecoilState(bookingState);
  const resetBooking = useResetRecoilState(bookingState);

  const [cartServices, setCartServices] = useRecoilState(servicesState);
  const [cartPackages, setCartPackages] = useRecoilState(packagesState);

  const [cart, setCart]= useRecoilState(cartState);

  const [cartLoading, setCartLoading]= useRecoilState(cartLoadingState);

  const [serviceableAreas, setServiceableAreas] = useState(null);
  const [confirmChangeLocation, setConfirmChangeLocation] = useRecoilState(confirmChangeLocationState);
  const [locationSupported, setLocationSupported] = useState(false);
  const [clearCart, setClearCart]= useRecoilState(clearCartState);
  
  const [setMappedCategories, isPrefillLoading, fillOption] = useMapPrefilledHook({})

  const [services, setServices] = useState(null);

  const [autoPopUpService, setAutoPopUpService]= useRecoilState(autoPopupServiceState);
  
  const [selectedRegion, setSelectedRegion] = useRecoilState(bookingRegionState);


  useEffect(
    () => {
      setCartLoading(loading || isPrefillLoading)
    }, [loading, isPrefillLoading]
  );

  const fetchServices = useCallback(
    async () => {
      setLoading(true)
      
      try {
        let params = {
          latitude: selectedRegion.location.latitude,
          longitude: selectedRegion.location.longitude,
        }

        // const resServices = await getServices({
        //   ...params
        // })

        const resCategories = await getFeaturedCategories({
          ...params
        })

        const mappedCategories = await mapCategoriesToServices(resCategories)
        setServiceCategories(mappedCategories)
        
        const resAreas = await getServicableAreas()

        setServiceableAreas(resAreas)
        // setServices(resServices)
        
        // const locsupport = isLocationSupportedForService({service: resServices})
        const locsupport = true
        setLocationSupported(locsupport)
        if (locsupport && confirmChangeLocation) {
          setClearCart(true)
          setBooking({
            ...booking,
            serviceCategory: null
          })
          setConfirmChangeLocation(false)
        }
        let categoriesObj = {}
        // resServices?.services?.forEach(service => {
        //   const categoryName = service?.type?.category
        //   const categoryServices = categoriesObj?.[categoryName] || []
        //   categoriesObj[categoryName] = [...categoryServices, service]
        // })
        const categories = Object.keys(categoriesObj).map(categoryName => ({
          name: categoryName,
          services: categoriesObj[categoryName]
        }))
        setServiceList(categories)
        if (locsupport && mappedCategories) {
          setMappedCategories(mappedCategories?.map(category => {
            return {
              ...category,
              services: category?.services?.map(service => {
                return {
                  ...service,
                  A_Booking: booking?.location,
                }
              })
            }
          }))
        }

        const {isCartValid, markedCartServices, markedCartPackages} = isCartValidForService({
          activeService: null,
          categories: mappedCategories,
          cart: {
            services: cartServices,
            packages: cartPackages
          }
        })

        setActiveService(null)
        setCartPackages(markedCartPackages)
        setCartServices(markedCartServices)
        // showInvalidCartConfirmDialog()
        
        setLoading(false)
      } catch (error) {
        trackEvent('Create Booking Featured Categories Error', { error: error?.message || error?.toString() })
        setLoading(false)
      }
    },
    [booking?.location, selectedRegion, cartPackages, cartServices, confirmChangeLocation],
  );

  useEffect(
    () => {
      fetchServices()
      setAutoPopUpService(null)
    }, []
  );
  const { getUser } = useUserState()
  const [session_token, setSession_token] = useRecoilState(sessionTokenState);

  const [activeService, setActiveService]= useRecoilState(activeServiceState);

  useUpdateEffect(() => {
    setBooking({
      ...booking,
      location: selectedRegion.location
    })
    fetchServices()
  }, [selectedRegion])

  const processCardSelection = useCallback(
    async (card) => {
      const { fillOptions, ...serviceCategory } = card
      const redirect = fillOptions?.prefill?.redirectStep || fillOptions?.destinationStep
      if (redirect) {
        const { isCartValid, markedCartServices, markedCartPackages } = isCartValidForService({
          categories: serviceCategories,
          cart: {
            services: [...fillOptions?.prefill?.services || []],
            packages: [...fillOptions?.prefill?.packages || []]
          }
        })
        setCartPackages(markedCartPackages)
        setCartServices(markedCartServices)
        
        setCart({
          services: markedCartServices,
          packages: markedCartPackages,
          booking: {
            ...booking,
            serviceCategory: fillOptions?.prefill?.serviceCategory
          }
        })

        setBooking({
          ...booking,
          serviceCategory: fillOptions?.prefill?.serviceCategory
        })
        setActiveService(serviceCategory?.featured_service)
        if (fillOptions?.canAddToCart) {
          setEnableCart(true)
        } else {
          setEnableCart(false)
        }
        setStep(redirect)
        history.replace(redirect, { internal: true })
      }

    },
    [booking, cartPackages, cartServices, setCartPackages, setCartServices, setStep, history, setEnableCart, serviceList, services],
  );
  
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"),
  {
    noSsr: true,
  });
  return (
    <>
      <PageHeader
        showLocationSetter
        backStep={null}
        currentStep={STEP_SERVICE_PACKAGES}
        title={"Which services would you like?"}
        subheader={""}
        isCartEnabled
        callToActionButton={
          isMobile &&
          <Suspense fallback={<Button variant="contained" disabled fullWidth>Loading...</Button>}>
            <CartButton
              isCartEnabled={STEP_CART_ENABLED.includes(step)}
            />
          </Suspense>
        }
        loading={loading || !!isPrefillLoading}
      >
        {!locationSupported ? (
          <>
            <Card>4
              <CardContent className={classes.locCard}>
                <h3>Your selected location is not within the servicable area</h3>
                <img src={serviceableAreas?.map} className={classes.map} />
                <Grid container spacing={2}>
                  {serviceableAreas?.cities?.map((city, index) => (
                    <Grid item xs={12} md={6} lg={3} key={index}>
                      <Typography variant="body2" color="textSecondary" className={classes.city}>
                        {city}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
            <Toolbar>
              <Button variant='contained'
                color='secondary'
                onClick={() => {
                  trackEvent('Create Booking Location Invalid - Change Location')
                  setStep(STEP_LOCATION)
                  history.replace(STEP_LOCATION, { internal: true })
                }}
                startIcon={<ChevronLeft />}
              >
                Change Location
              </Button>
            </Toolbar>

          </>
        ) : (
          <>
            {serviceCategories?.map((servicePackage, index) => (
              <ServiceRows
                canAddToCart={enableCart}
                key={index}
                category={servicePackage}
                onSelect={async (card) => {
                  await processCardSelection(card)
                }}
              />
            ))}
          </>
        )}
      </PageHeader>

    </>
  )
}

export { ServicePackagesScreen };
